export default {
    manage_inputs: "Inputs",
    manage_inputs_columTitle: "Input Label",
    manage_inputs_onLabel: "Input ON Label",
    manage_inputs_offLabel: "Input OFF Label",
    manage_inputs_search_by_input_label: "Search by Input Label"
}